import { render, staticRenderFns } from "./SmallArticle.vue?vue&type=template&id=307de90e&scoped=true"
import script from "./SmallArticle.vue?vue&type=script&lang=js"
export * from "./SmallArticle.vue?vue&type=script&lang=js"
import style0 from "./SmallArticle.vue?vue&type=style&index=0&id=307de90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307de90e",
  null
  
)

export default component.exports